import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageMeta from '../../components/PageMeta';
import { getGuideBySlug } from '../../data/guides';
import './ContentPage.css';

const GuideArticle = () => {
  const { slug } = useParams();
  const guide = getGuideBySlug(slug);

  if (!guide) {
    return <Navigate to="/guides" replace />;
  }

  return (
    <div className="content-page">
      <PageMeta
        title={guide.title}
        description={guide.description}
        path={`/guides/${guide.slug}`}
        type="article"
      />
      <Header />
      <header className="content-hero">
        <div className="content-hero-inner">
          <Link to="/guides" className="guide-back-link">← Back to Guides</Link>
          <span className="content-category">{guide.category}</span>
          <h1 className="content-hero-title">{guide.title}</h1>
          <p className="content-hero-desc">{guide.description}</p>
          <div className="content-meta">
            <span>{guide.readTimeMinutes} min read</span>
            <span>Published {guide.publishedAt}</span>
          </div>
        </div>
      </header>

      <main className="content-main">
        {guide.sections.map((block, index) => (
          <section key={block.h || index} className="content-block">
            <h2>{block.h}</h2>
            {block.p?.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
            {block.list && (
              <ul>
                {block.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className="content-related">
          <h2>Explore more</h2>
          <ul className="content-related-links">
            <li><Link to="/guides">All guides</Link></li>
            <li><Link to="/market">Browse fresh produce</Link></li>
            <li><Link to="/farmers">Find local farmers</Link></li>
            <li><Link to="/seller-guide">Seller Guide</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GuideArticle;
